export const REAL_PRIZE = 'REAL_PRIZE';
export const POINT = 'POINT';
export const COUPON = 'COUPON';
export const POSTER = 'POSTER';
export const NO_PRIZE = 'NO_PRIZE';
//状态
export const NOT_START = 'NOT_PRIZE';
//领取实物奖品方式
export const POST = 'POST';
export const TAKE_THEIR = 'TAKE_THEIR';
export const prizeTypeList = [
  { name: '实物奖', value: REAL_PRIZE },
  { name: '积分', value: POINT },
  { name: '优惠券', value: COUPON },
  { name: '海报', value: POSTER },
];
export const acceptWayList = [
  { name: '邮寄', value: POST },
  { name: '到店自取', value: TAKE_THEIR },
];
